import { useCallback } from 'react';
import type { RcFile } from 'ui';
import type { AttachmentsFormContentValues } from '../components';
import { useUploadEventAttachmentMutation } from '../queries';

type UploadEventAttachmentsParams = { attachments: AttachmentsFormContentValues['attachments']; eventId: string };

export const useUploadEventAttachments = () => {
  const { isPending, mutateAsync: uploadEventAttachment } = useUploadEventAttachmentMutation();

  const uploadEventAttachments = useCallback(
    async ({ attachments, eventId }: UploadEventAttachmentsParams) => {
      const attachmentFiles =
        attachments?.fileList
          .map((attachment) => attachment.originFileObj)
          .filter((file): file is RcFile => file !== undefined) ?? [];

      if (attachmentFiles.length === 0) {
        return;
      }

      await Promise.all(
        attachmentFiles.map(async (file) =>
          uploadEventAttachment({
            eventId,
            file,
          }),
        ),
      );
    },
    [uploadEventAttachment],
  );

  return {
    isUploadingAttachments: isPending,
    uploadEventAttachments,
  };
};
